import $ from 'jquery';

$(function () {
  if (!$('.js-deactivation-select-group').length) {
    return;
  }

  $('.js-deactivation-type').change(function () {
    $('.js-deactivation-select-group').addClass('hidden');
    $(
      ".js-deactivation-select-group[data-type='" + this.value + "']",
    ).removeClass('hidden');
  });

  $('#group_membership_group_id').change(function () {
    var text = $(this)
      .parent('.js-deactivation-select-group')
      .find('button.dropdown-toggle')
      .text();
    $('.js-deactivation-select-group button.dropdown-toggle').text(text);
    $('.js-deactivation-select-group select').val(this.value);
  });
});
